var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListMySessions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6049_2961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7947 12.7711C16.4026 12.7711 15.1316 13.3159 14.1632 14.3448V11.6816H18.5816H18.6421C19.55 11.6816 20.3368 10.9553 20.3368 9.9869V5.3869C20.3368 5.26585 20.2763 5.20533 20.1553 5.20533H17.3105V1.87638C17.3105 0.968483 16.5842 0.181641 15.6158 0.181641H15.5553H1.99737C1.02895 0.181641 0.302635 0.907956 0.302635 1.87638V21.2448C0.302635 22.1527 1.02895 22.879 1.93685 22.879H12.7105C13.6184 22.879 14.3447 22.1527 14.3447 21.2448V21.1237C15.2526 22.1527 16.5842 22.6974 17.9763 22.6974C20.7 22.6974 22.879 20.458 22.879 17.7948C22.7579 15.0106 20.5184 12.7711 17.7947 12.7711ZM19.9132 5.56848V9.9869C19.9132 10.7132 19.3079 11.3185 18.5816 11.3185C17.8553 11.3185 17.25 10.7132 17.25 9.9869V5.56848H19.9132ZM16.8868 1.87638V5.3869C17.0684 9.32111 16.4632 10.4711 17.5526 11.3185H14.2237V1.87638C14.2237 1.15006 14.829 0.544798 15.5553 0.544798C16.2816 0.544798 16.8868 1.15006 16.8868 1.87638ZM13.8605 21.1843C13.8605 21.8501 13.3158 22.4553 12.5895 22.4553H1.87632C1.21053 22.4553 0.605267 21.9106 0.605267 21.1843V1.81585C0.605267 1.08954 1.21053 0.484272 1.93685 0.484272H14.5263C14.1026 0.84743 13.9211 1.33164 13.9211 1.81585V14.7685C13.2553 15.6159 12.9526 16.6448 12.9526 17.7343C12.9526 18.8237 13.3158 19.8527 13.9211 20.7001L13.8605 21.1843ZM17.7947 22.2737C15.2526 22.2737 13.2553 20.2159 13.2553 17.7343C13.2553 15.2527 15.2526 13.1948 17.7947 13.1948C20.3368 13.1948 22.3342 15.2527 22.3342 17.7343C22.3342 20.2159 20.3368 22.2737 17.7947 22.2737Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4605 18.0968C18.5211 17.9757 18.5816 17.8547 18.5816 17.7336C18.5816 17.3705 18.3395 17.0678 18.0368 17.0073V15.7363C18.0368 15.6152 17.9763 15.5547 17.8553 15.5547C17.7342 15.5547 17.6737 15.6152 17.6737 15.7363V16.9468C17.3711 17.0073 17.129 17.31 17.129 17.6731C17.129 18.0968 17.4921 18.3994 17.8553 18.3994C17.9763 18.3994 18.1579 18.3389 18.2184 18.2784L19.1868 19.2468C19.2474 19.3073 19.2474 19.3073 19.3079 19.3073C19.3684 19.3073 19.429 19.3073 19.429 19.2468C19.4895 19.1863 19.4895 19.0652 19.429 19.0047L18.4605 18.0968ZM17.3711 17.7336C17.3711 17.4915 17.5526 17.3705 17.7342 17.3705C17.9763 17.3705 18.0974 17.5521 18.0974 17.7336C18.0974 17.8547 18.0368 17.9757 17.9763 18.0363C17.9158 18.0968 17.7947 18.1573 17.6737 18.1573C17.5526 18.0968 17.3711 17.9152 17.3711 17.7336Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20527 2.8457H2.72369C2.60263 2.8457 2.54211 2.90623 2.54211 3.02728V5.44833C2.54211 5.56939 2.60263 5.62991 2.72369 5.62991H5.14474C5.26579 5.62991 5.32632 5.56939 5.32632 5.44833V3.02728C5.38684 2.96676 5.26579 2.8457 5.20527 2.8457ZM5.02369 5.32728H2.90526V3.26939H4.96316L5.02369 5.32728Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8632 3.38867H6.53685C6.4158 3.38867 6.35527 3.4492 6.35527 3.57025C6.35527 3.6913 6.4158 3.75183 6.53685 3.75183H11.8026C11.9237 3.75183 11.9842 3.6913 11.9842 3.57025C12.0447 3.4492 11.9842 3.38867 11.8632 3.38867Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59737 4.90222H9.68422C9.80527 4.90222 9.86579 4.84169 9.86579 4.72064C9.86579 4.59959 9.80527 4.53906 9.68422 4.53906H6.59737C6.47632 4.53906 6.41579 4.59959 6.41579 4.72064C6.41579 4.84169 6.47632 4.90222 6.59737 4.90222Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20527 6.47656H2.72369C2.60263 6.47656 2.54211 6.53709 2.54211 6.65814V9.07919C2.54211 9.20025 2.60263 9.26077 2.72369 9.26077H5.14474C5.26579 9.26077 5.32632 9.20025 5.32632 9.07919V6.65814C5.38684 6.59762 5.26579 6.47656 5.20527 6.47656ZM5.02369 8.95814H2.90526V6.90025H4.96316L5.02369 8.95814Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8632 6.96094H6.53685C6.4158 6.96094 6.35527 7.02146 6.35527 7.14252C6.35527 7.26357 6.4158 7.3241 6.53685 7.3241H11.8026C11.9237 7.3241 11.9842 7.26357 11.9842 7.14252C12.0447 7.02146 11.9842 6.96094 11.8632 6.96094Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59737 8.47449H9.68422C9.80527 8.47449 9.86579 8.41396 9.86579 8.29291C9.86579 8.17185 9.80527 8.11133 9.68422 8.11133H6.59737C6.47632 8.11133 6.41579 8.17185 6.41579 8.29291C6.41579 8.41396 6.47632 8.47449 6.59737 8.47449Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20527 10.1074H2.72369C2.60263 10.1074 2.54211 10.1679 2.54211 10.289V12.7101C2.54211 12.8311 2.60263 12.8916 2.72369 12.8916H5.14474C5.26579 12.8916 5.32632 12.8311 5.32632 12.7101V10.289C5.38684 10.1679 5.26579 10.1074 5.20527 10.1074ZM5.02369 12.5285H2.90526V10.4706H4.96316L5.02369 12.5285Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8632 10.5918H6.53685C6.4158 10.5918 6.35527 10.6523 6.35527 10.7734C6.35527 10.8944 6.4158 10.955 6.53685 10.955H11.8026C11.9237 10.955 11.9842 10.8944 11.9842 10.7734C12.0447 10.6523 11.9842 10.5918 11.8632 10.5918Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59737 12.1053H9.68422C9.80527 12.1053 9.86579 12.0448 9.86579 11.9238C9.86579 11.8027 9.80527 11.7422 9.68422 11.7422H6.59737C6.47632 11.7422 6.41579 11.8027 6.41579 11.9238C6.41579 12.0448 6.47632 12.1053 6.59737 12.1053Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20527 13.7402H2.72369C2.60263 13.7402 2.54211 13.8008 2.54211 13.9218V16.3429C2.54211 16.4639 2.60263 16.5244 2.72369 16.5244H5.14474C5.26579 16.5244 5.32632 16.4639 5.32632 16.3429V13.9218C5.38684 13.8008 5.26579 13.7402 5.20527 13.7402ZM5.02369 16.1613H2.90526V14.1034H4.96316L5.02369 16.1613Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59737 14.223C6.47632 14.223 6.41579 14.2835 6.41579 14.4045C6.41579 14.5256 6.47632 14.5861 6.59737 14.5861C11.8026 14.5256 12.0447 14.7677 12.0447 14.4045C12.0447 14.0414 11.8026 14.2835 6.59737 14.223Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59737 15.7362H9.68422C9.80527 15.7362 9.86579 15.6757 9.86579 15.5546C9.86579 15.4336 9.80527 15.373 9.68422 15.373H6.59737C6.47632 15.373 6.41579 15.4336 6.41579 15.5546C6.41579 15.6757 6.47632 15.7362 6.59737 15.7362Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20527 17.3105H2.72369C2.60263 17.3105 2.54211 17.3711 2.54211 17.4921V19.9132C2.54211 20.0342 2.60263 20.0948 2.72369 20.0948H5.14474C5.26579 20.0948 5.32632 20.0342 5.32632 19.9132V17.4921C5.38684 17.4316 5.26579 17.3105 5.20527 17.3105ZM5.02369 19.7921H2.90526V17.7342H4.96316L5.02369 19.7921Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8632 17.7949H6.53685C6.4158 17.7949 6.35527 17.8554 6.35527 17.9765C6.35527 18.0976 6.4158 18.1581 6.53685 18.1581H11.8026C11.9237 18.1581 11.9842 18.0976 11.9842 17.9765C12.0447 17.916 11.9842 17.7949 11.8632 17.7949Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68422 19.0059H6.59737C6.47632 19.0059 6.41579 19.0664 6.41579 19.1874C6.41579 19.3085 6.53685 19.369 6.59737 19.369H9.68422C9.80527 19.369 9.86579 19.3085 9.86579 19.1874C9.86579 19.0664 9.80527 19.0059 9.68422 19.0059Z",
    fill: "#6F82C4",
    stroke: "#6F82C4",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6049_2961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListMySessions);
export default __webpack_public_path__ + "static/media/listMySessions.2217792680d56ae6f8689982e5775208.svg";
export { ForwardRef as ReactComponent };